import { openExternal } from 'global/viewSettings/helpers/settingsLinks';
import { useCallback, useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { ParentContext } from '../ParentContext';
import { deleteField } from 'firebase/firestore';
import { createRefPath_client } from 'global/firestoreData/appData/appRefPaths';
import { appUserManagerHandlers, appUserManagerInitialState, appUserManagerReducer } from 'global/cnr/reducers/AppUserManagerReducer';
import { dispatchProps } from 'global/cnr/reducers/reducerHelpers/dispatchProps';
import { sendPasswordResetEmail } from 'firebase/auth';
import { _authProjectName } from 'global/components/user/UserAuth';

export const useAppUser = ({
  selectedAppUser,
}) => {

  const { email, _itemKey } = selectedAppUser ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers, settings, fns, fn_cls } = parentContext ?? {}
  const { app_state, paps_state, currentSettings_state } = states
  const { mainAuth } = app_state ?? {}
  const { pathViews } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appSignIn, signInEmail } = aps_global ?? {}
  const { homeSettings } = settings ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { logging } = homeSettings_global ?? {}
  const { database_fns } = fns

  const [showAppManagerType, setShowAppManagerType] = useState()
  const [selectedAppUserAuth, setSelectedAppUserAuth] = useState()

  const handleGet_authByEmail = useCallback(() => {
    const cb = (au) => {
      setSelectedAppUserAuth(au)
    }
    fn_cls.getAuthByEmail(selectedAppUser, cb, _authProjectName)
  }, [openExternal]);

  const handleOpen_auth = useCallback(() => {
    openExternal.firebaseAuth();
  }, [openExternal]);

  const handleOpen_profile = useCallback(() => {
    openExternal.firebaseProfile(
      paps_state.pathViews,
      paps_state.pathViews.clients ? email : _itemKey
    );
  }, [openExternal, paps_state, email, _itemKey]);

  const handleSend_passwordReset = useCallback(() => {
    sendPasswordResetEmail(mainAuth, email).then(() => {
      dispatch && dispatch({ type: dispatchProps.success, dispatch, content: 'The email has been sent' })
    }).catch(error => {
      console.log('error', error)
      dispatch && dispatch({ type: dispatchProps.error, error, dispatch, content: 'The email has NOT been sent' })
    })
  }, [email]);

  const handleReset_disclaimerResponses = useCallback(() => {
    const _refPath = createRefPath_client(pathViews, ['profiles', email]);

    const dataToUpdate = {
      disclaimerResponses: deleteField()
    };

    database_fns.update_docc({
      refPath: _refPath,
      data: dataToUpdate
    });
  }, [email]);

  const handleSend_email = useCallback(() => {
    const nd = {
      email: {
        recipient: selectedAppUserAuth.email,
        sender: 'support@meetingevolution.net',
        subject,
        body,
      }
    }
    fn_cls.sendEmail(nd).then(response_data => {
      const { success, error } = response_data ?? {}
      dispatch && dispatch({ type: success ? dispatchProps.success : dispatchProps.error, error, dispatch, content: 'The Email has been sent' })
      // handleCancel()
    }).catch(error => {

    })
  }, []);

  const handleSend_notification = useCallback(() => {
    const notificationData = {
      title,
      body,
      sharePath,
    }

    if (pathViews.clients) { notificationData.clientKey = pathViews.clients }
    if (pathViews.events) { notificationData.eventKey = pathViews.events }

    fn_cls.sendNotificationToSelf({ notificationData, appUserAccess: selectedAppUserAuth, paps_state, logging }).then(response_data => {
      const { success, error } = response_data ?? {}
      console.log('response_data', response_data)
      dispatch && dispatch({ type: success ? dispatchProps.success : dispatchProps.error, error, dispatch, content: 'The message has been sent' })
    }).catch(error => {
      handleCancel()
      console.error(error);
    })
  }, []);

  const handleSend_sms = useCallback(() => {
    const data = {
      to: selectedAppUserAuth.phoneNumber,
      text,
    }
    fn_cls.sendSms(data, logging).then(response_data => {
      const { success, error } = response_data ?? {}
      dispatch && dispatch({ type: success ? dispatchProps.success : dispatchProps.error, error, dispatch, content: 'The message has been sent' })
    }).catch(error => {
      handleCancel()
      console.error(error);
    })
  }, []);

  const handleShow_appManagerType = useCallback((showManagerType) => {
    setShowAppManagerType(showManagerType)
  }, []);

  return {
    showAppManagerType,
    appUserFns: {
      handleGet_authByEmail,
      handleOpen_auth,
      handleOpen_profile,
      handleReset_disclaimerResponses,
      handleSend_email,
      handleSend_notification,
      handleSend_passwordReset,
      handleSend_sms,
      handleShow_appManagerType,
    }
  };
};
